const BlankEmployee = 
        {
            EmployeeID:-1,
            EmployeeNo:"",
            LastName:"",
            FirstName:"",
            MiddleName:"",
            Department:"Inflight Services",
            Position:'',
            Location:'',
            Username:'',
            RoleType:'USER',
            Company:'5J',
            AccessGroup:'1',
            FPCount:0,
            PIN:'',
        };

var  GetBlankEmployee = () =>
{
    return JSON.parse(JSON.stringify(BlankEmployee));
}

module.exports=GetBlankEmployee;


// WEBPACK FOOTER //
// ./src/admin/BlankEmployee.js